import api from './api'

export interface PrivacySettings {
    hide_lead_contacts: boolean
    block_lead_edit: boolean
    block_lead_delete: boolean
    block_lead_blocking: boolean
    hide_dashboard: boolean
    hide_broadcast_queue: boolean
    hide_lead_cards: boolean
    hide_duplicates: boolean
    // TG ID лида - отдельно от остальных контактов.
    hide_telegram_id: boolean
}

// Что скрывать от операторов. Настройка общая на систему, доступна тимлиду и
// суперадмину.
export const privacyApi = {
    getSettings: () => api.get<PrivacySettings>('/privacy/settings'),

    updateSettings: (data: Partial<PrivacySettings>) =>
        api.put<PrivacySettings>('/privacy/settings', data),
}

export interface FeatureSettings {
    // Счётчик непрочитанных гаснет только после ответа оператора.
    mark_read_on_reply_only: boolean
    // Красный счётчик непрочитанных на плашке папки чатов.
    folder_unread_badges: boolean
    // Полный запрет заводить лида руками.
    block_manual_lead_create: boolean
    // Вместо пустой формы - окно поиска карточки по ID CRM Wiseway.
    crm_id_only_lead_create: boolean
    // Кнопка «Добавить в лиды» в диалоге.
    chat_lead_create_enabled: boolean
    // Видимость лидов по профилям для ролей без права «Видеть все карточки».
    profile_visibility_enabled: boolean
}

// Подраздел «Доп. функции». Доступ тот же, что у настроек приватности.
export const featuresApi = {
    getSettings: () => api.get<FeatureSettings>('/privacy/features'),

    updateSettings: (data: Partial<FeatureSettings>) =>
        api.put<FeatureSettings>('/privacy/features', data),
}
